import React from 'react';
const vendors = ['AMD / Xilinx', 'Intel / Altera', 'Lattice Semiconductor', 'Microchip', 'Achronix', 'Efinix'];
export function VendorLogos() {
  return <div className="py-12 border-y border-gate-border/30 bg-gate-surface/20" data-id="element-276">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-277">
        <p className="text-center text-sm font-medium text-gate-text-muted mb-8 uppercase tracking-widest" data-id="element-278">
          Supported Hardware Providers
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-8" data-id="element-279">
          {vendors.map(vendor => <div key={vendor} className="text-xl font-bold text-gate-text-muted hover:text-white transition-colors duration-300 cursor-default" data-id="element-280">
              {vendor}
            </div>)}
        </div>
      </div>
    </div>;
}